import React, {useEffect, useState} from 'react';

// material
import {Page, Content, Button, InContentMessage, parseQueryString, history} from "@insticator/insticator-ui";
import DisabledGlobalFilter from "../monetizationform/filter/disabledglobalfilter/disabledglobalfilter";
import Header from "../../../../material/structure/header/header";
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from '../../../../material/structure/pagecontent/pagecontent';
import CardWrapper from "../../../../material/cardwrapper/cardwrapper";
import SectionGroup from "../../../../material/expandablesection/sectiongroup/sectiongroup";

// redux
import {useDispatch, useSelector} from "react-redux";
import {toggleIsOpened, initReportForm, updateReportForm} from "../../../../state/slices/report";
import {fetchAllReportsByAccount} from "../../../../state/thunks/report";

// styles
import injectSheet from "react-jss";
import styles from "./newreport_styles";
import MonetizationForm from "../monetizationform/monetizationformv2";
import {Redirect} from "react-router";

// static
const CREATE_NEW_INTRO_MSG = 'Report Builder allows you to create monetization reports by defining dimensions and metrics you want to include in an immediate download or a scheduled recurring email.'
const BTN_TXT = 'Create New Report'

/* ========== ~~~~~~~~~~ REPORT BUILDER / CREATE NEW REPORT ~~~~~~~~~~ ========== */
export default injectSheet(styles)(({classes}) => {
    const reportRequestStatus = useSelector((state) => state.report.reportRequestStatus);
    const error = useSelector((state) => state.report.error);
    const reportCreated = useSelector((state) => state.report.reportCreated);
    const accountUUID = useSelector((state) => state.session.accountUUID);
    const query = useSelector((state) => state.router.location.query);

    const [isCreatingReport, setIsCreatingReport] = useState(false);
    const { skipbutton } = parseQueryString(window.location.search);

    const dispatch = useDispatch();

    const handleButtonClick = () => {
        setIsCreatingReport(true);
        history.push('/dashboard/reportbuilder/new?firstReport=true')
    }

    // Show or hide new report if user navigates forward or backward
    useEffect(() => {
        setIsCreatingReport(query['firstReport'])
    }, [query])

    // this is to check duplicated names
    useEffect(() => {
        if (accountUUID && skipbutton === 'true') dispatch(fetchAllReportsByAccount(accountUUID));
    }, [accountUUID])


    const intro = <div className={classes.wrapper}>
        <div className={classes.createNewMessageBox}>
            <p>{CREATE_NEW_INTRO_MSG}</p>
            <Button
                variant={'primary'}
                text={BTN_TXT}
                type={'action'}
                handleClick={handleButtonClick}
            />
        </div>
    </div>

    const newReport = <CardWrapper klass={classes.cardWrapper}>
                        <SectionGroup>
                            <MonetizationForm
                                uuid={'newReport'}
                                reportActionType={'Create New Report'}
                                handleNewFormCancel={() => setIsCreatingReport(false)}
                            />
                        </SectionGroup>
                      </CardWrapper>

    if (reportRequestStatus === 'error') {
        if (error.includes('404')) return <Redirect to={'/error/404'}/>
        return <Redirect to={'/error/500'}/>
    }

    if (reportCreated) return <Redirect to={'/dashboard/reportbuilder/allreports'}/>

    return (
        <Page name={`Report Builder`} klass={classes.newReport}>
            <Content klass={`newreport-${!(isCreatingReport || skipbutton === 'true')}`}>
                <InContentMessage />
                <PageHeader title={'Report Builder'}/>
                <PageContent>{(isCreatingReport || skipbutton === 'true') ? newReport : intro}</PageContent>
            </Content>
        </Page>
    )
});